module.exports = __webpack_public_path__ + "media/images/icons/tiktok_black-af464ed7071d111fb092d2f97a7acd75.svg";